import { IInventoryPage } from '../../../inventory-page.interface';


export const UPLOAD_POD_TM_REPORT_PAGE: IInventoryPage = {
	'route': '/upload/pod/tm-report',
	'title': 'TM Report',
	'uiReference': [
		'Start date',
		'End date',
		'Report scope',
		'Trademark activity',
		'Review trademark matches for a calendar week and trademark office.',
		'Refresh',
		'Year',
		'Calendar Week',
		'Date Range',
		'&ndash;',
		'Derived from the selected calendar week',
		'Country',
		'Report view',
		'Switch between trademark records and affected designs.',
		'Legal Notice: This is not legal advice, we are not responsible for the use and checking of trademarks. Each user is responsible for the correctness of the trademarks himself.',
		'Checking Listings',
		'No Trademarks Found',
		'No Listings Created Yet?',
		'No Entries Found.',
		'Trademarks Not Available Yet',
		'Loading...',
		'( of )',
		'Remaining',
		'Stop',
		'Sorry, there was an internal error. Please contact support.',
		'Search trademark',
		'Edit trademark designs',
		'Trademark matches',
		'results',
		'filed',
		'registered',
		'Filter Options',
		'Refine results',
		'Limit this report by office, Nice class, or trademark status.',
		'Reset filters',
		'TM Offices',
		'Nice Class',
		'Status',
		'Options',
		'Loading Designs: %',
		'Affected designs',
		'listings',
		'Filter options',
		'Refine designs',
		'Filter affected listings by trademark office, Nice class, or registration status.',
		'Loading designs',
		'Loading affected designs',
		'% complete',
		'About remaining',
		'No matching designs',
		'Try clearing one or more filters to see affected listings.',
		'Close trademark details',
		'Add to Watchlist',
		'Search Applicant',
		'View',
		'TM Name',
		'Applicant',
		'Office',
		'Application',
		'Number',
		'Registration',
		'See Trademark Listings',
		'View Designs',
		'Edit Designs',
		'NEW',
		'See trademarks',
		'Imported'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/pod-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-report/tm-report.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-report/tm-report.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-report/tm-report.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/progress-loader-card/progress-loader-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/progress-loader-card/progress-loader-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-report/report-list-view/report-list-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-report/report-list-view/report-list-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-report/report-design-view/report-design-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-report/report-design-view/report-design-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-details/tm-detail.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-details/tm-detail.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-details/tm-detail.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-report/shared/report-design-carousel/report-design-carousel.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-report/shared/report-design-carousel/report-design-carousel.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-report/shared/report-design-card/report-design-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/trademarks/tm-report/shared/report-design-card/report-design-card.component.html'
	],
	'aliases': []
};
